import React from 'react';
import {BrowserRouter,Switch,Route,HashRouter} from 'react-router-dom'
import 'antd-mobile/dist/antd-mobile.css';
import './App.css';

import Loading from './views/loading/index';
import Home1 from './views/home1/index';
import Home2 from './views/home2/index';
import Login from './views/login/index';
import Account1 from './views/account1/index';
import Account2 from './views/account2/index';
import Account3 from './views/account3/index';
import List from './views/list/index';
import Detail from './views/detail/index';
import PregnCalculat1 from './views/pregnCalculat1/index';
import PregnCalculat2 from './views/pregnCalculat2/index';
import PregnCalculat11 from './views/pregnCalculat11/index';
import PregnCalculat12 from './views/pregnCalculat12/index';

// import VConsole from 'vconsole';
// const isDebug = true;
// if (isDebug) {
//   new VConsole()
// }

function App() {
  return (
    <HashRouter>
      <Route exact path="/" component={Loading} />
      <Route path="/loading" component={Loading} />
      <Route path="/home1" component={Home1} />
      <Route path="/home2" component={Home2} />
      <Route path="/login/:id" component={Login} />
      <Route path="/account1" component={Account1} />
      <Route path="/account2" component={Account2} />
      <Route path="/account3" component={Account3} />
      <Route path="/list" component={List} />
      <Route path="/detail" component={Detail} />
      <Route path="/pregnCalculat1" component={PregnCalculat1} />
      <Route path="/pregnCalculat2/:index/:time" component={PregnCalculat2} />
      <Route path="/pregnCalculat11" component={PregnCalculat11} />
      <Route path="/pregnCalculat12/:index/:time" component={PregnCalculat12} />
    </HashRouter>
  )
}

export default App;
